import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { WHY_SOLARNOVA } from '../data/mock';
import { Check, Award } from 'lucide-react';

export const WhySolarNova = () => {
  const [ref, inView] = useInView({ threshold: 0.1 });

  return (
    <section ref={ref} className="relative py-28 bg-gradient-to-br from-[#0B3D5C] to-[#0D1B2A] overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D4952B]/5 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left side */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7 }}
          >
            <span className="text-[#E8B84A] text-sm font-semibold tracking-[0.2em] uppercase">Why Choose Us</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 leading-tight">
              Why SolarNova
            </h2>
            <p className="text-2xl md:text-3xl text-white/25 font-semibold mt-2 font-['Noto_Sans_Arabic']">لماذا سولارنوفا</p>
            <p className="text-white/45 mt-6 text-base leading-relaxed max-w-md">
              With a heritage spanning four decades and a manufacturing facility in the heart of the Kingdom, SolarNova is uniquely positioned to power Saudi Arabia's renewable future.
            </p>

            {/* Quality badge */}
            <div className="mt-8 inline-flex items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
              <div className="w-14 h-14 rounded-xl bg-[#D4952B]/20 flex items-center justify-center flex-shrink-0">
                <Award className="w-7 h-7 text-[#E8B84A]" />
              </div>
              <div>
                <div className="text-white font-bold text-sm">Quality & Certifications</div>
                <p className="text-white/40 text-xs mt-1 leading-relaxed">
                  Individual cell-level testing, desert-specific protocols, IEC standards compliance, and 5-year warranty.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Right side - reasons grid */}
          <div className="grid gap-4">
            {WHY_SOLARNOVA.map((reason, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 30 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.15 + i * 0.08 }}
                className="group flex items-start gap-4 bg-white/[0.04] hover:bg-white/[0.08] border border-white/5 hover:border-[#D4952B]/20 rounded-xl p-5 transition-all duration-500"
              >
                <div className="w-8 h-8 rounded-lg bg-[#D4952B]/10 group-hover:bg-[#D4952B]/20 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors duration-500">
                  <Check className="w-4 h-4 text-[#E8B84A]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-sm">{reason.title}</h3>
                  <p className="text-white/40 text-xs mt-1 leading-relaxed">{reason.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
